import { isFullMatch } from './live';

import type { Match } from '@shared-types/match.types';
import { MatchStatus } from '@shared-types/match.types';

const getVariant = (match: Match, hasHighlights: boolean, variant: string) => {
  if (variant === 'highlights button') return variant;

  let result: string = null;
  switch (match.status) {
    case MatchStatus.UPCOMING:
      result = 'pre';
      break;
    case MatchStatus.LIVE:
      result = 'live';
      break;
    case MatchStatus.FINISHED:
      result = 'post';
      if (hasHighlights) result += ' with highlights';
      break;
  }

  if (variant) result += ` ${variant}`;

  return result;
};

export const getMatchTracking = (match: Match, hasHighlights: boolean, variant?: string) => {
  if (!isFullMatch(match)) return null;

  return {
    id: match.id,
    name: `${match.homeTeam?.internationalName} vs ${match.awayTeam?.internationalName}`,
    category: 'match card',
    variant: getVariant(match, hasHighlights, variant),
  };
};
